import $fetch from '@/services/client'
import type { InitBody } from '@/services/schemas'

async function initData(params: InitBody) {
  const response = await $fetch('mycontroller/init/json', {
    body: {
      lang: params.lang,
      isocode: params.isocode,
    },
    cache: 'force-cache',
    priority: 'high',
  })
  if (response.error) throw new Error(response.error.statusText + response.error.message)

  return response.data
}

export default initData
